import { NOT_FOUND_ROUTE_NAME } from './public-routes.js'

export const routes = [
  {
    path: '/login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false, title: 'Connexion - Alertis' }
  },
  {
    path: '/veille',
    component: () => import('../views/Veille.vue'),
    meta: { requiresAuth: true, title: 'Référentiel qualité - Alertis' }
  },
  {
    path: '/feedback',
    component: () => import('../views/Feedback.vue'),
    meta: { requiresAuth: true, title: 'Feedback & suggestions - Alertis' }
  },
  {
    path: '/veille/:type',
    component: () => import('../views/VeilleReglementaire.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Veille - Alertis' }
  },
  {
    path: '/veille-reglementaire',
    redirect: '/veille/reglementaire'
  },
  {
    path: '/',
    component: () => import('../views/QuotesList.vue'),
    meta: { requiresAuth: true, title: 'Liste des demandes - Alertis' }
  },
  {
    path: '/dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Tableau de bord - Alertis' }
  },
  {
    path: '/tasks/today',
    component: () => import('../views/TasksToday.vue'),
    meta: { requiresAuth: true, title: 'Mes tâches du jour - Alertis' }
  },
  {
    path: '/tasks/history',
    component: () => import('../views/TasksHistory.vue'),
    meta: { requiresAuth: true, title: 'Historique des tâches - Alertis' }
  },
  {
    path: '/quotes/:id',
    component: () => import('../views/QuoteDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Détail de la demande - Alertis' }
  },
  {
    path: '/quotes/:id/analyse-besoin',
    component: () => import('../views/QuoteBesoinTunnel.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Analyse du besoin - Alertis' }
  },
  {
    // Aperçu (mode test) du tunnel « Analyse du besoin » avec des données
    // d'exemple, sans demande réelle. Chemin distinct de /quotes/:id/... pour
    // éviter toute collision avec la route dynamique ci-dessus.
    path: '/formations/questionnaires-qualif/apercu-tunnel',
    component: () => import('../views/QuoteBesoinTunnel.vue'),
    props: { preview: true, id: 'apercu' },
    meta: { requiresAuth: true, title: 'Aperçu du tunnel - Alertis' }
  },
  {
    path: '/users',
    component: () => import('../views/UsersManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Gestion des utilisateurs - Alertis' }
  },
  {
    path: '/logs',
    component: () => import('../views/Logs.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Journaux - Alertis' }
  },
  {
    path: '/form',
    component: () => import('../views/QuoteForm.vue'),
    meta: { requiresAuth: true, title: 'Formulaire - Alertis' }
  },
  {
    path: '/embed/form',
    component: () => import('../views/QuoteFormEmbed.vue'),
    meta: { requiresAuth: false, title: 'Formulaire - Alertis' }
  },
  {
    path: '/embed/map',
    component: () => import('../views/TrainingCentersMapEmbed.vue'),
    meta: { requiresAuth: false, title: 'Carte des centres de formation - Alertis' }
  },
  {
    path: '/email-preferences',
    component: () => import('../views/EmailPreferences.vue'),
    meta: { requiresAuth: true, title: 'Préférences email - Alertis' }
  },
  {
    path: '/email-templates-preview',
    component: () => import('../views/EmailTemplatesPreview.vue'),
    // Ouverte aux commerciaux, mais SEULEMENT sur les modèles atteignables
    // depuis leurs fiches : le catalogue est filtré par rôle côté serveur
    // (server/constants/email-preview-audience.js), et le lien du menu reste
    // dans la section administration. Sans cet accès, le lien « Voir le
    // modèle » de l'historique d'e-mails d'une demande les renverrait à
    // l'accueil.
    meta: { requiresAuth: true, title: 'Modèles d\'e-mail - Alertis' }
  },
  {
    path: '/pdf-templates-preview',
    component: () => import('../views/PdfTemplatesPreview.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Modèles de document - Alertis' }
  },
  {
    path: '/contacts',
    component: () => import('../views/ContactsList.vue'),
    meta: { requiresAuth: true, title: 'Liste des contacts - Alertis' }
  },
  {
    // Le SIRET désigne l'établissement quand la personne en représente plusieurs.
    path: '/contacts/:email/:siret(\\d+)?',
    component: () => import('../views/ContactDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Détail du contact - Alertis' }
  },
  // Les structures, à part des personnes : un établissement (SIRET) par ligne.
  {
    path: '/entreprises',
    component: () => import('../views/EntreprisesDevisList.vue'),
    meta: { requiresAuth: true, title: 'Liste des entreprises - Alertis' }
  },
  {
    // La fiche de l'établissement : la même que celle d'un contact
    // professionnel, vue depuis l'entreprise — sans les informations d'UNE
    // personne. L'e-mail est celui par lequel l'API ouvre la fiche.
    path: '/entreprises/:email/:siret(\\d+)',
    component: () => import('../views/ContactDetail.vue'),
    props: (route) => ({ email: route.params.email, siret: route.params.siret, entreprise: true }),
    meta: { requiresAuth: true, title: 'Fiche entreprise - Alertis' }
  },
  {
    path: '/conciergerie',
    component: () => import('../views/ConciergerieList.vue'),
    meta: { requiresAuth: true, title: 'Conciergerie - Alertis' }
  },
  {
    // « Recherche » : tout salarié suit ses missions en cours et en publie aux
    // formateurs de la zone (/recherche/nouvelle). Pages neuves, sans v1.
    path: '/recherche',
    component: () => import('../views/Recherche.vue'),
    meta: { requiresAuth: true, title: 'Recherche - Alertis' }
  },
  {
    path: '/recherche/nouvelle',
    component: () => import('../views/RechercheNouvelle.vue'),
    meta: { requiresAuth: true, title: 'Publier une mission - Alertis' }
  },
  {
    // La fiche d'une mission de Recherche : ce qu'on a publié, qui a répondu,
    // et le choix. L'onglet « Missions » sert un autre parcours, plus large.
    path: '/recherche/:id(\\d+)',
    component: () => import('../views/RechercheMissionDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Mission - Alertis' }
  },
  {
    path: '/conciergerie/:id(\\d+)',
    component: () => import('../views/ConciergerieDossierDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Dossier de conciergerie - Alertis' }
  },
  {
    // Le permalien d'un fichier. Ouvert sans session du back-office : un
    // formateur y arrive aussi, et c'est la page qui demande le fichier au
    // serveur avec la session de celui qui clique (cf. conciergerie-liens.js).
    path: '/conciergerie/fichiers/:fichierId(\\d+)',
    component: () => import('../views/ConciergerieFichierLien.vue'),
    props: true,
    meta: { requiresAuth: false, title: 'Fichier de conciergerie - Alertis' }
  },
  {
    path: '/inter-sessions',
    component: () => import('../views/InterSessionsList.vue'),
    meta: { requiresAuth: true, title: 'Sessions Inter-entreprise - Alertis' }
  },
  {
    path: '/company-profiles/:id',
    component: () => import('../views/CompanyProfileDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Profil entreprise - Alertis' }
  },
  {
    path: '/calendar',
    component: () => import('../views/Calendar.vue'),
    meta: { requiresAuth: false, title: 'Planning interactif - Alertis' }
  },
  {
    path: '/appointment',
    component: () => import('../views/Appointment.vue'),
    meta: { requiresAuth: false, title: 'Rendez-vous téléphonique - Alertis' }
  },
  {
    path: '/sign-quote',
    component: () => import('../views/SignQuote.vue'),
    meta: { requiresAuth: false, title: 'Signature du devis - Alertis' }
  },
  {
    path: '/calendar-management',
    component: () => import('../views/CalendarManagement.vue'),
    meta: { requiresAuth: true, title: 'Mon planning - Alertis' }
  },
  {
    path: '/admin/calendar-management',
    component: () => import('../views/AdminCalendarManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Planning des commerciaux - Alertis' }
  },
  // Panneau d'activité commerciale (§7.3 de docs/activity-panel-spec.md) — 3 routes,
  // 1 seul composant conteneur.
  {
    path: '/admin/activite',
    redirect: '/admin/activite/equipe'
  },
  {
    path: '/admin/activite/equipe',
    component: () => import('../views/admin/ActivityPanel.vue'),
    props: { tab: 'equipe' },
    meta: { requiresAuth: true, requiresSuperAdmin: true, title: 'Activité commerciale - Équipe - Alertis' }
  },
  {
    path: '/admin/activite/commercial/:id?',
    component: () => import('../views/admin/ActivityPanel.vue'),
    props: true,
    meta: { requiresAuth: true, requiresSuperAdmin: true, title: 'Activité commerciale - Commercial - Alertis' }
  },
  {
    path: '/admin/activite/journee',
    component: () => import('../views/admin/ActivityPanel.vue'),
    props: { tab: 'journee' },
    meta: { requiresAuth: true, requiresSuperAdmin: true, title: 'Journée - Activité commerciale - Alertis' }
  },
  {
    path: '/statistics',
    component: () => import('../views/Statistics.vue'),
    meta: { requiresAuth: true, title: 'Statistiques commerciales - Alertis' }
  },
  {
    path: '/pointeuse',
    component: () => import('../views/Pointeuse.vue'),
    meta: { requiresAuth: true, requiresRoleComplementaire: 'pointeuse', title: 'Pointeuse - Alertis' }
  },
  {
    path: '/formations-catalogue',
    component: () => import('../views/FormationsCatalogue.vue'),
    meta: { requiresAuth: true, title: 'Catalogue des formations - Alertis' }
  },
  {
    path: '/formations/categories',
    component: () => import('../views/formations/FormationCategories.vue'),
    // Admin : l'écran ne gère plus des couleurs mais le référentiel entier —
    // compétences déclarées par les formateurs et parcours d'auto-formation.
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Catégories de formations - Alertis' }
  },
  {
    path: '/formations/messages',
    component: () => import('../views/formations/FormationMessages.vue'),
    meta: { requiresAuth: true, title: 'Messages de formation - Alertis' }
  },
  {
    path: '/admin/cv-referentiels',
    component: () => import('../views/admin/CvReferentiels.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Référentiels du CV formateur - Alertis' }
  },
  {
    path: '/admin/auto-formations',
    component: () => import('../views/AutoFormationsManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Auto-formations - Alertis' }
  },
  {
    path: '/formations/argumentaires',
    component: () => import('../views/formations/FormationArgumentaires.vue'),
    meta: { requiresAuth: true, title: 'Argumentaire commercial - Alertis' }
  },
  {
    path: '/formations/questionnaires-qualif',
    component: () => import('../views/formations/FormationQualificationQuestionnaires.vue'),
    meta: { requiresAuth: true, title: 'Questionnaire - Alertis' }
  },
  // Les blocs communs se créent et se modifient depuis la page « Questionnaire ».
  { path: '/formations/blocs-communs', redirect: '/formations/questionnaires-qualif' },
  {
    path: '/formations/questionnaires-formation',
    component: () => import('../views/formations/FormationQuestionnaires.vue'),
    meta: { requiresAuth: true, title: 'Questionnaires de formation - Alertis' }
  },
  {
    path: '/api-keys',
    component: () => import('../views/ApiKeysManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Gestion des clés API - Alertis' }
  },
  {
    path: '/quote-notification-emails',
    component: () => import('../views/QuoteNotificationEmails.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Configuration des emails - Alertis' }
  },
  {
    path: '/quote-line-designations',
    component: () => import('../views/QuoteLineDesignationsManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Gestion des désignations de lignes de devis - Alertis' }
  },
  {
    path: '/api-docs',
    // La page n'est plus publique : celui qui lit la documentation est celui
    // qui crée les clés, et les clés se créent dans /api-keys, réservée aux
    // administrateurs. Retirée en même temps des deux autres listes de routes
    // publiques : router/guards.js et composables/useAppRouting.js.
    component: () => import('../views/ApiDocumentation.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Documentation API - Alertis' }
  },
  {
    path: '/unsubscribe',
    component: () => import('../views/Unsubscribe.vue'),
    meta: { requiresAuth: false, title: 'Désabonnement - Alertis' }
  },
  {
    path: '/quotes/:id/formation-programme-pdf',
    component: () => import('../views/DownloadFormationProgramme.vue'),
    props: true,
    meta: { requiresAuth: false, title: 'Téléchargement du programme de formation - Alertis' }
  },
  {
    path: '/analytics/quote-attempts',
    component: () => import('../views/QuoteAttemptsAnalytics.vue'),
    meta: { requiresAuth: true, title: 'Tentatives de devis - Alertis' }
  },
  {
    path: '/analytics/quote-attempts/:id',
    component: () => import('../views/QuoteAttemptDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Détail de la tentative - Alertis' }
  },
  {
    path: '/inscriptions',
    component: () => import('../views/InscriptionsList.vue'),
    meta: { requiresAuth: true, title: 'Inscriptions - Alertis' }
  },
  {
    path: '/organisation-formation',
    component: () => import('../views/OrganisationFormationList.vue'),
    meta: { requiresAuth: true, title: 'Organisation formation - Alertis' }
  },
  {
    path: '/organisation-formation/:reponseId/missionner',
    component: () => import('../views/OrganisationMissionner.vue'),
    meta: { requiresAuth: true, title: 'Missionner un formateur - Alertis' }
  },
  {
    path: '/inscriptions/:id',
    component: () => import('../views/InscriptionDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Détail inscription - Alertis' }
  },
  {
    path: '/inscriptions/:id/questionnaires/:envoiId',
    component: () => import('../views/QuestionnaireReadonlyView.vue'),
    meta: { requiresAuth: true, title: 'Questionnaire - Alertis' }
  },
  {
    path: '/inscription/success',
    component: () => import('../views/public/InscriptionPaymentSuccess.vue'),
    meta: { requiresAuth: false, title: 'Paiement confirmé - Alertis' }
  },
  {
    path: '/inscription/payer',
    component: () => import('../views/public/InscriptionPayer.vue'),
    meta: { requiresAuth: false, title: 'Paiement de votre formation - Alertis' }
  },
  {
    path: '/inscription',
    component: () => import('../views/public/InscriptionPublicForm.vue'),
    meta: { requiresAuth: false, title: 'Formulaire d\'inscription - Alertis' }
  },
  {
    path: '/prestataire',
    component: () => import('../views/public/PrestataireResponsePage.vue'),
    meta: { requiresAuth: false, title: 'Confirmation de disponibilité - Alertis' }
  },
  {
    path: '/emargement',
    component: () => import('../views/public/EmargementPublicPage.vue'),
    meta: { requiresAuth: false, title: 'Émargement - Alertis' }
  },
  {
    path: '/emargement-formateur',
    component: () => import('../views/public/FormateurEmargementPage.vue'),
    meta: { requiresAuth: false, title: 'Emargement formateur - Alertis' }
  },
  {
    path: '/questionnaire-formation',
    component: () => import('../views/public/QuestionnaireFormationPublic.vue'),
    meta: { requiresAuth: false, title: 'Questionnaire de formation - Alertis' }
  },
  {
    path: '/inscription-formateur',
    component: () => import('../views/public/FormateurInscriptionForm.vue'),
    meta: { requiresAuth: false, title: 'Inscription formateur - Alertis' }
  },
  {
    path: '/inscription-formateur/verifier-email',
    component: () => import('../views/public/FormateurEmailVerification.vue'),
    meta: { requiresAuth: false, title: 'Vérification email - Alertis' }
  },
  {
    // Le rendez-vous annuel du formateur : signer son contrat de sous-traitance,
    // puis relire ses informations professionnelles. Ouverte depuis le lien de
    // l'email du 1er janvier, elle ne demande jamais de mot de passe.
    path: '/contrat-annuel',
    component: () => import('../views/public/ContratAnnuelPage.vue'),
    meta: { requiresAuth: false, title: 'Contrat annuel de sous-traitance - Alertis' }
  },
  {
    // « Me désinscrire », depuis le rappel mensuel d'une inscription jamais
    // finie : la fiche part en corbeille, sans compte ni mot de passe.
    path: '/desinscription-formateur',
    component: () => import('../views/public/FormateurDesinscription.vue'),
    meta: { requiresAuth: false, title: 'Désinscription formateur - Alertis' }
  },
  {
    path: '/formateurs',
    component: () => import('../views/FormateursList.vue'),
    meta: { requiresAuth: true, title: 'Formateurs - Alertis' }
  },
  {
    // Doit précéder /formateurs/:id (sinon « imports » serait capté comme :id).
    path: '/formateurs/imports',
    component: () => import('../views/FormateurImports.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Imports & Campagne formateurs - Alertis' }
  },
  {
    // Doit précéder /formateurs/:id (sinon « statistiques » serait capté comme :id).
    path: '/formateurs/statistiques',
    component: () => import('../views/FormateursStatistiques.vue'),
    meta: { requiresAuth: true, title: 'Statistiques des formateurs - Alertis' }
  },
  {
    path: '/formateurs/:id',
    component: () => import('../views/FormateurDetail.vue'),
    props: true,
    meta: { requiresAuth: true, title: 'Détail formateur - Alertis' }
  },
  {
    path: '/moderation-avis',
    component: () => import('../views/avis/ModerationAvis.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Avis & signalements - Alertis' }
  },
  // L'ancienne page des modules : leurs questions vivent désormais dans la
  // partie « organisation » des questionnaires de qualification.
  { path: '/questionnaire-organisation', redirect: '/formations/questionnaires-qualif' },
  {
    path: '/admin/settings',
    component: () => import('../views/AppSettings.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Paramètres - Alertis' }
  },
  {
    path: '/admin/sponsored-content',
    component: () => import('../views/admin/SponsoredContentManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Contenus sponsorisés - Alertis' }
  },
  {
    path: '/admin/sponsored-content/stats',
    component: () => import('../views/admin/SponsoredContentStats.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Statistiques contenus sponsorisés - Alertis' }
  },
  {
    path: '/missions',
    component: () => import('../views/MissionsList.vue'),
    meta: { requiresAuth: true, title: 'Missions - Alertis' }
  },
  {
    path: '/missions/:id',
    component: () => import('../views/MissionDetail.vue'),
    meta: { requiresAuth: true, title: 'Détail mission - Alertis' }
  },
  {
    path: '/missions/:id/diffusion',
    component: () => import('../views/MissionMapDiffusion.vue'),
    meta: { requiresAuth: true, title: 'Diffuser la mission - Alertis' }
  },
  {
    path: '/messagerie-formateurs',
    component: () => import('../views/MessagerieFormateurs.vue'),
    meta: { requiresAuth: true, title: 'Messagerie formateurs - Alertis' }
  },
  {
    path: '/mission-reponse',
    component: () => import('../views/public/MissionReponsePage.vue'),
    meta: { requiresAuth: false, title: 'Réponse mission - Alertis' }
  },
  {
    path: '/formateur-facture',
    component: () => import('../views/public/FormateurFactureUploadPage.vue'),
    meta: { requiresAuth: false, title: 'Téléversement facture - Alertis' }
  },
  {
    path: '/questionnaire-organisation-public',
    component: () => import('../views/public/QuestionnaireOrganisationPublic.vue'),
    meta: { requiresAuth: false, title: 'Questionnaire organisation - Alertis' }
  },
  {
    path: '/questionnaire-organisation/liste-stagiaires',
    component: () => import('../views/public/ListeStagiairesPublic.vue'),
    meta: { requiresAuth: false, title: 'Liste des stagiaires - Alertis' }
  },
  // Espace Formateur
  {
    path: '/espace-formateur/login',
    component: () => import('../views/formateur/FormateurLogin.vue'),
    meta: { requiresAuth: false, title: 'Espace Formateur - Connexion' }
  },
  // Missions, Publier une mission, Réponses à ma publication et Avis ont quitté
  // cet espace le 27/08/2026 : ce sont des rubriques Global Prévention, servies
  // sur son site. Leurs adresses restent en place pour les favoris et les
  // anciens e-mails, et renvoient vers le bon endroit au lieu d'un 404.
  {
    path: '/espace-formateur/missions',
    component: () => import('../views/formateur/FormateurRubriqueDeplaceeGp.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Missions - Global Prévention' }
  },
  {
    path: '/espace-formateur/missions/:id/positionnements',
    component: () => import('../views/formateur/FormateurRubriqueDeplaceeGp.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Positionnements - Global Prévention' }
  },
  {
    path: '/espace-formateur/publier-une-mission',
    component: () => import('../views/formateur/FormateurRubriqueDeplaceeGp.vue'),
    meta: {
      requiresAuth: false,
      requiresFormateurAuth: true,
      title: 'Publier une mission - Global Prévention'
    }
  },
  {
    // La page d'accueil de l'espace : ce que le formateur anime bientôt, son
    // agenda, ce qu'il reste à compléter dans son dossier, ses CV par thème.
    // C'est là que mène la connexion depuis le 08/09/2026 — « Mes formations »
    // accueillait jusque-là par « Aucun résultat » tout formateur sans mission
    // attribuée, c'est-à-dire tout nouvel inscrit.
    path: '/espace-formateur/tableau-de-bord',
    component: () => import('../views/formateur/FormateurTableauDeBord.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Tableau de bord - Espace Formateur' }
  },
  {
    // La racine de l'espace : les favoris et les anciens liens y arrivent.
    path: '/espace-formateur',
    redirect: '/espace-formateur/tableau-de-bord'
  },
  {
    path: '/espace-formateur/mes-formations',
    component: () => import('../views/formateur/FormateurMesFormations.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Mes formations - Espace Formateur' }
  },
  {
    path: '/espace-formateur/mes-formations/:id',
    component: () => import('../views/formateur/FormateurFormationDetail.vue'),
    props: true,
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Detail formation - Espace Formateur' }
  },
  {
    path: '/espace-formateur/conciergerie',
    component: () => import('../views/formateur/FormateurConciergerie.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Conciergerie - Espace Formateur' }
  },
  {
    path: '/espace-formateur/conciergerie/:id(\\d+)',
    component: () => import('../views/formateur/FormateurConciergerieDossier.vue'),
    props: true,
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Dossier - Espace Formateur' }
  },
  {
    path: '/espace-formateur/calendrier',
    component: () => import('../views/formateur/FormateurCalendar.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Mon calendrier - Espace Formateur' }
  },
  {
    path: '/espace-formateur/profil',
    component: () => import('../views/formateur/FormateurMonProfilV2.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Mon profil - Espace Formateur' }
  },
  {
    path: '/espace-formateur/comptes-rendus',
    component: () => import('../views/formateur/FormateurComptesRendus.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Comptes rendus - Espace Formateur' }
  },
  {
    path: '/espace-formateur/materiel',
    redirect: { path: '/espace-formateur/comptes-rendus', query: { tab: 'materiel' } }
  },
  {
    path: '/espace-formateur/materiel/:id(\\d+)',
    component: () => import('../views/formateur/FormateurMannequinDetail.vue'),
    props: true,
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Registre d\'entretien - Espace Formateur' }
  },
  {
    path: '/espace-formateur/comptes-rendus/nouveau',
    component: () => import('../views/formateur/FormateurCompteRenduChoix.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Nouveau compte-rendu - Espace Formateur' }
  },
  {
    path: '/espace-formateur/comptes-rendus/evacuation/:type(general|type_r|type_ju)',
    component: () => import('../views/formateur/FormateurCompteRenduEvacuation.vue'),
    props: true,
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Compte-rendu d\'évacuation - Espace Formateur' }
  },
  {
    path: '/espace-formateur/comptes-rendus/evacuation',
    redirect: '/espace-formateur/comptes-rendus/nouveau'
  },
  {
    path: '/espace-formateur/comptes-rendus/:id(\\d+)',
    component: () => import('../views/formateur/FormateurCompteRenduDetail.vue'),
    props: true,
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Compte-rendu - Espace Formateur' }
  },
  {
    path: '/espace-formateur/comptes-rendus/:id(\\d+)/modifier',
    component: () => import('../views/formateur/FormateurCompteRenduEvacuation.vue'),
    props: route => ({ docId: route.params.id }),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Modifier un compte-rendu - Espace Formateur' }
  },
  {
    // « Mes documents » n'a plus d'écran à elle : le dossier du formateur (pièces
    // administratives, certificats, supports, RIB, CV) se tient d'un seul tenant
    // dans « Mon profil ». La navigation ne proposait plus cette adresse depuis
    // longtemps ; elle reste servie pour les favoris et les anciens e-mails, qui
    // arrivent désormais en haut du dossier — là où le bandeau annonce ce qui
    // manque. Pas de `?tab=documents` : ce paramètre est réservé au retour de
    // l'éditeur de CV, qui vise la section des CV.
    path: '/espace-formateur/documents',
    redirect: '/espace-formateur/profil'
  },
  {
    path: '/espace-formateur/cv/:categorie',
    component: () => import('../views/formateur/FormateurCvEditorV2.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Éditeur de CV - Espace Formateur' }
  },
  {
    path: '/espace-formateur/avis',
    component: () => import('../views/formateur/FormateurRubriqueDeplaceeGp.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Avis - Global Prévention' }
  },
  // Auto formations (quiz)
  {
    path: '/espace-formateur/auto-formations',
    component: () => import('../views/formateur/FormateurAutoFormations.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Auto formations - Espace Formateur' }
  },
  {
    path: '/espace-formateur/auto-formations/module/:id',
    component: () => import('../views/formateur/FormateurAutoFormationModule.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Module - Auto formations' }
  },
  {
    path: '/espace-formateur/auto-formations/quiz/:id',
    component: () => import('../views/formateur/FormateurAutoFormationQuiz.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Quiz - Auto formations' }
  },
  {
    path: '/espace-formateur/auto-formations/attestation/:id',
    component: () => import('../views/formateur/FormateurAutoFormationAttestation.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Attestation - Auto formations' }
  },
  {
    path: '/espace-formateur/auto-formations/:themeSlug',
    component: () => import('../views/formateur/FormateurAutoFormationTheme.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Thème - Auto formations' }
  },
  // Vérification publique d'une attestation d'auto-formation (QR code)
  {
    path: '/verifier-attestation/:ref',
    component: () => import('../views/public/VerifierAttestationPage.vue'),
    meta: { requiresAuth: false, title: 'Vérification d\'attestation - Alertis' }
  },
  // Raccourci depuis le site public Global Prévention (« Ajouter un avis »)
  {
    path: '/avis',
    redirect: '/espace-formateur/avis'
  },
  {
    path: '/espace-formateur/messages',
    component: () => import('../views/formateur/FormateurMessages.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Messages - Espace Formateur' }
  },
  {
    path: '/espace-formateur/contrats',
    component: () => import('../views/portail/PortailContrats.vue'),
    meta: { requiresAuth: false, requiresFormateurAuth: true, title: 'Mes contrats - Espace Formateur' }
  },
  // Espace Entreprise
  {
    path: '/espace-entreprise/login',
    component: () => import('../views/entreprise/EntrepriseLogin.vue'),
    meta: { requiresAuth: false, title: 'Espace Entreprise - Connexion' }
  },
  {
    path: '/espace-entreprise/dashboard',
    component: () => import('../views/entreprise/EntrepriseDashboardV2.vue'),
    meta: { requiresAuth: false, requiresEntrepriseAuth: true, title: 'Tableau de bord - Espace Entreprise' }
  },
  {
    path: '/espace-entreprise/stagiaires',
    component: () => import('../views/entreprise/EntrepriseStagiaires.vue'),
    meta: { requiresAuth: false, requiresEntrepriseAuth: true, title: 'Mes stagiaires - Espace Entreprise' }
  },
  {
    path: '/espace-entreprise/stagiaires/:id',
    component: () => import('../views/entreprise/EntrepriseStagiaireDetail.vue'),
    props: true,
    meta: { requiresAuth: false, requiresEntrepriseAuth: true, title: 'Détail stagiaire - Espace Entreprise' }
  },
  {
    path: '/espace-entreprise/documents',
    component: () => import('../views/entreprise/EntrepriseDocuments.vue'),
    meta: { requiresAuth: false, requiresEntrepriseAuth: true, title: 'Documents - Espace Entreprise' }
  },
  // Espace Stagiaire
  {
    path: '/espace-stagiaire/login',
    component: () => import('../views/stagiaire/StagiaireLogin.vue'),
    meta: { requiresAuth: false, title: 'Espace Stagiaire - Connexion' }
  },
  {
    path: '/espace-stagiaire/dashboard',
    component: () => import('../views/stagiaire/StagiaireDashboard.vue'),
    meta: { requiresAuth: false, requiresStagiaireAuth: true, title: 'Tableau de bord - Espace Stagiaire' }
  },
  {
    path: '/espace-stagiaire/formations',
    component: () => import('../views/stagiaire/StagiaireMesFormationsV2.vue'),
    meta: { requiresAuth: false, requiresStagiaireAuth: true, title: 'Mes formations - Espace Stagiaire' }
  },
  {
    path: '/espace-stagiaire/formations/:inscriptionId',
    component: () => import('../views/stagiaire/StagiaireFicheFormationV2.vue'),
    props: true,
    meta: { requiresAuth: false, requiresStagiaireAuth: true, title: 'Détail formation - Espace Stagiaire' }
  },
  {
    path: '/espace-stagiaire/questionnaires',
    component: () => import('../views/stagiaire/StagiaireQuestionnaires.vue'),
    meta: { requiresAuth: false, requiresStagiaireAuth: true, title: 'Questionnaires - Espace Stagiaire' }
  },
  // Debug (dev/staging)
  {
    path: '/debug',
    component: () => import('../views/DebugSettings.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Horloge système - Alertis' }
  },
  // Debug tools
  {
    path: '/debug/emails',
    component: () => import('../views/DebugEmails.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Debug - Emails interceptés' }
  },
  {
    path: '/debug/sms',
    component: () => import('../views/DebugSms.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Debug - SMS interceptés' }
  },
  {
    path: '/debug/clean-db',
    component: () => import('../views/DebugCleanDb.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Debug - Nettoyage BDD' }
  },
  // Page introuvable : TOUJOURS la dernière. vue-router classe les routes par
  // précision, donc elle ne masque ni une route réelle ni une redirection ;
  // elle ne reçoit que ce qui ne correspond à rien. Sans session, elle est un
  // écran public (cf. NOT_FOUND_ROUTE_NAME dans public-routes.js).
  {
    path: '/:pathMatch(.*)*',
    name: NOT_FOUND_ROUTE_NAME,
    component: () => import('../views/PageIntrouvable.vue'),
    meta: { requiresAuth: false, title: 'Page introuvable - Alertis' }
  }
]
